var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "approval-checklist-detail-index details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: { "left-style": { flex: "none", "max-width": "190px" } }
        },
        [
          _c("template", { slot: "left" }, [
            _c("div", { staticClass: "app-main-content" }, [
              _c("div", { staticClass: "grid-view" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      flex: "1"
                    }
                  },
                  [
                    _c("el-tree", {
                      staticClass: "custom-category-list section",
                      staticStyle: { width: "180px" },
                      attrs: {
                        "highlight-current": "",
                        "node-key": "id",
                        data: _vm.leftData,
                        "current-node-key": _vm.currentNodeKey
                      },
                      on: { "node-click": _vm.handleSelect }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "app-main-content" }, [
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _vm.activeMenu === "1"
                    ? _c(
                        "el-tabs",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "card" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.lookActiveTab,
                            callback: function($$v) {
                              _vm.lookActiveTab = $$v
                            },
                            expression: "lookActiveTab"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookAll" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookAll"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookAll",
                                    attrs: {
                                      status: -1,
                                      type: "look",
                                      "config-module": "23030701",
                                      "show-initiate-btn": true,
                                      "view-source":
                                        _vm.VIEW_SOURCE_INITIATE_ALL,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookProcessing" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Processing")
                                      ) +
                                      " "
                                  ),
                                  _vm.initiated.processingCount > 0
                                    ? _c("el-badge", {
                                        attrs: {
                                          value: _vm.initiated.processingCount
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.lookActiveTab === "lookProcessing"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookProcessing",
                                    attrs: {
                                      status: 0,
                                      type: "look",
                                      "config-module": "23030702",
                                      "view-source":
                                        _vm.VIEW_SOURCE_INITIATE_PROCESSING,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookCompleted" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Completed1")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookCompleted"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookCompleted",
                                    attrs: {
                                      type: "look",
                                      status: 1,
                                      "config-module": "23030703",
                                      "show-print-btn": true,
                                      "view-source":
                                        _vm.VIEW_SOURCE_INITIATE_COMPLETED,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookRevoked" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Revoked")) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookRevoked"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookRevoked",
                                    attrs: {
                                      status: 2,
                                      type: "look",
                                      "config-module": "23030704",
                                      "view-source":
                                        _vm.VIEW_SOURCE_INITIATE_REVOKED,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-tabs",
                        {
                          attrs: { type: "card" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.approveActiveTab,
                            callback: function($$v) {
                              _vm.approveActiveTab = $$v
                            },
                            expression: "approveActiveTab"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveAll" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveAll"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveAll",
                                    attrs: {
                                      type: "approve",
                                      status: -1,
                                      "config-module": "23030705",
                                      "show-print-btn": true,
                                      "query-all": true,
                                      "view-source": _vm.VIEW_SOURCE_HANDLE_ALL,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approvePending" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Pending")) +
                                      " "
                                  ),
                                  _vm.approve.processingCount > 0
                                    ? _c("el-badge", {
                                        attrs: {
                                          value: _vm.approve.processingCount
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.approveActiveTab === "approvePending"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approvePending",
                                    attrs: {
                                      type: "approve",
                                      status: 0,
                                      "config-module": "23030706",
                                      "view-source":
                                        _vm.VIEW_SOURCE_HANDLE_TODO,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveCompleted" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Completed1")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveCompleted"
                                ? _c("approval-checklist-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveCompleted",
                                    attrs: {
                                      type: "approve",
                                      status: 1,
                                      "config-module": "23030707",
                                      "view-source":
                                        _vm.VIEW_SOURCE_HANDLE_COMPLETED,
                                      "document-config-id": _vm.documentConfigId
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }